<template>
  <v-card
    class="control-tooltip"
    :style="`border: 4px solid ${color}`"
    border-md
  >
    <template v-slot:title>
      <span class="text-h6 text-primary">
        {{ tooltipInfo?.techInfo?.location }}
      </span>
    </template>
    <v-divider v-if="tooltipInfo?.techInfo" />
    <v-card-text class="bg-aliceBlue">
      <slot></slot>
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
defineProps<{
  hasDataIssues?: boolean;
  tooltipInfo?: {
    techInfo?: {
      [key: string]: string | number | object;
    };
  };
  color?: string;
}>();
</script>
<style lang="scss" scoped>
.control-tooltip {
  padding: 5px 0 0 0;
  opacity: 1 !important;
  background-color: #fff;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.3);
}

.v-alert :deep(.v-alert__border) {
  opacity: 1 !important;
}
</style>
